import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { useIncome } from './hooks/useIncome';
import Sidebar from './components/Sidebar';
import Toast from './components/Toast';
import GigFlowBot from './components/GigFlowBot';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import AddIncome from './pages/AddIncome';
import Transactions from './pages/Transactions';
import Analytics from './pages/Analytics';
import Forecast from './pages/Forecast';
import Settings from './pages/Settings';

function AppShell() {
  const { user, isDark, notification, notify } = useAuth();
  const { incomeData, fetchIncome, addCustomSource, deleteCustomSource, allSources } = useIncome(user, notify);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="app-shell">
      <Toast notification={notification} />

      {!user ? (
        <AuthPage />
      ) : (
        <>
          <Sidebar isOpen={isSidebarOpen} closeMobile={closeSidebar} width="280px" />
          <main className="main-content">
            <GigFlowBot />
            <Routes>
              <Route path="/" element={<Dashboard incomeData={incomeData} toggleSidebar={toggleSidebar} />} />
              <Route
                path="/add"
                element={
                  <AddIncome
                    loadIncome={fetchIncome}
                    incomeData={incomeData}
                    allSources={allSources}
                    addCustomSource={addCustomSource}
                    deleteCustomSource={deleteCustomSource}
                    toggleSidebar={toggleSidebar}
                  />
                }
              />
              <Route path="/transactions" element={<Transactions incomeData={incomeData} loadIncome={fetchIncome} allSources={allSources} toggleSidebar={toggleSidebar} />} />
              <Route path="/analytics" element={<Analytics incomeData={incomeData} toggleSidebar={toggleSidebar} isDark={isDark} />} />
              <Route path="/forecast" element={<Forecast incomeData={incomeData} allSources={allSources} toggleSidebar={toggleSidebar} />} />
              <Route path="/settings" element={<Settings toggleSidebar={toggleSidebar} />} />
            </Routes>
          </main>
        </>
      )}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppShell />
      </Router>
    </AuthProvider>
  );
}
